import React from 'react';
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";

const StrategicPartnerLabel = () => <>{STRATEGIC_PARTNER.LABEL}</>;

export default StrategicPartnerLabel;